import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { RoleAddSchema } from "../../../ValidationSchema";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const CmsAdd = () => {
  const Navigate = useNavigate();
  const [userRole, setUserRole] = useState([]);
  const [initialValues] = useState({
    name: "",
  });

  const AddCMS = useFormik({
    initialValues,
    validationSchema: RoleAddSchema,

    onSubmit: (values, action) => {
      axios
        .post(`${process.env.REACT_APP_URL}/admin/roles/store`, values, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            toast.success(`${res?.data?.message}`);
            Navigate("/admin/role", { state: res.data.msg });
          }
        })
        .catch((err) => {
          toast.error(err.response.data.msg);
        });
    },
  });

  //   const UserRole = () => {
  //     axios
  //       .get(`${process.env.REACT_APP_URL}/common/roles`)
  //       .then((res) => {
  //         setUserRole(res.data.roles);
  //       })
  //       .catch((err) => {
  //         if (err.response.data.message === "Unauthorized!") {
  //           Navigate("/admin/login");
  //         }
  //       });
  //   };

  useEffect(() => {
    // UserRole();
  }, []);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Add CMS</h1>
          <p className="al-sub">Create a new CMS entry.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={AddCMS.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></svg></div>
            <h3 className="al-cardhead__title">CMS Details</h3>
          </div>
          <div className="al-form">
            <div className="al-form__full">
              <label className="al-label">Key</label>
              <input className="al-input" type="text" placeholder="Enter Key"
                value={AddCMS.values.key} onChange={AddCMS.handleChange} onBlur={AddCMS.handleBlur} name="key" />
              {AddCMS.errors.key && AddCMS.touched.key ? (
                <div className="al-err">{AddCMS.errors.key}</div>
              ) : null}
            </div>

            <div className="al-form__full">
              <label className="al-label">Description</label>
              <CKEditor
                editor={ClassicEditor}
                data={AddCMS.values.description}
                className="custom-ckeditor"
                onChange={(event, editor) => {
                  const data = editor.getData();
                  AddCMS.setFieldValue("description", data);
                }}
                onBlur={() => AddCMS.setFieldTouched("description", true)}
              />
              {AddCMS.errors.description && AddCMS.touched.description && (
                <div className="al-err">{AddCMS.errors.description}</div>
              )}
            </div>
          </div>
          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
              Create CMS
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CmsAdd;
